import { Container, Title, CardsWrapper } from "./HowItWorksStyles";
import { motion } from "framer-motion";
import { fadeUp } from "../../styles/animations";
import HowItWorksCard from "../howItWorksCard/HowItWorksCard";
import { useNavigate } from "react-router-dom";
import ButtonGradient from "../ui/ButtonGradient";

const steps = [
  {
    title: "Cadastro Simples",
    description:
      "Inscreva-se rapidamente preenchendo informações como nome artístico, e-mail, estilo musical e adicionando sua foto de perfil.",
  },
  {
    title: "Criação de Portfólio",
    description:
      "Configure seu portfólio em poucos passos com seções automáticas e opções de personalização.",
  },
  {
    title: "Visualização Prévia",
    description: "Confira como seu portfólio ficará antes de publicá-lo.",
  },
  {
    title: "URL Personalizada",
    description:
      "Garanta um link exclusivo (ex: www.presskit.com/seu-nome-dj) para compartilhar com facilidade.",
  },
  {
    title: "Administração Prática",
    description:
      "Atualize seu portfólio sempre que necessário através de uma interface intuitiva.",
  },
];

const HowItWorks = () => {
  const navigate = useNavigate();

  return (
    <Container id="how">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
      >
        <Title>Como Funciona?</Title>
      </motion.div>

      <CardsWrapper>
        {steps.map((step, index) => (
          <motion.div
            key={index}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            custom={index + 1}
            viewport={{ once: false, amount: 0.1 }}
          >
            <HowItWorksCard {...step} />
          </motion.div>
        ))}
      </CardsWrapper>
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.1 }}
        custom={2}
      >
        <ButtonGradient onClick={() => navigate("/login")}>
          Comece agora: <br />
          <strong>Crie seu portfólio grátis!</strong>{" "}
        </ButtonGradient>
      </motion.div>
    </Container>
  );
};

export default HowItWorks;
